import * as RadixToast from "@radix-ui/react-toast";
import clsx from "clsx";

import { CheckCircle, ExclamationTriangle } from "../Icon/default";
import { ToastProps } from "./type";

export const Toast = ({ item: { isOpen, id, description, type = "success" }, onClose }: ToastProps) => (
  <RadixToast.Root open={isOpen} onOpenChange={(shown) => !shown && onClose(id)} className="mt-4">
    <RadixToast.Title
      className={clsx(
        "text-ui14 shadow-mid flex w-[350px] max-w-[350px] items-center justify-center gap-2 rounded px-6 py-3",
        type === "success" && "bg-functional-notice-light",
        type === "error" && "bg-functional-danger-light",
      )}
    >
      <span className="h-6 w-6">
        {type === "success" && <CheckCircle className="stroke-functional-notice" />}
        {type === "error" && <ExclamationTriangle className="fill-functional-danger" />}
      </span>
      <div
        className={clsx(
          "line-clamp-2 font-bold",
          type === "success" && "text-functional-notice",
          type === "error" && "text-functional-danger",
        )}
      >
        {description}
      </div>
    </RadixToast.Title>
  </RadixToast.Root>
);
